import { render, staticRenderFns } from "./form.html?vue&type=template&id=1dd229ed&"
import script from "./EditLbRef.vue?vue&type=script&lang=js&"
export * from "./EditLbRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports